import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import InputField from "components/fields/InputField";
import { publicPost } from "lib/apiClient";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    if (next.length < 10) return setError("Use at least 10 characters.");
    if (next !== confirm) return setError("The passwords do not match.");
    setBusy(true);
    try {
      await publicPost("/portal/auth/password-reset/confirm", { token, newPassword: next });
      setDone(true);
    } catch (err) {
      setError(err.code === "PASSWORD_RESET_TOKEN_INVALID" ? "This link has expired or was already used. Request a new one." : err.message || "Could not reset the password.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex w-full">
      <div className="w-full">
        <h4 className="mb-1.5 text-2xl font-semibold tracking-tight text-foreground">Choose a new password</h4>
        {!token ? (
          <p className="mb-6 text-sm text-muted-foreground">This reset link is incomplete. Open the link from your email again, or request a new one.</p>
        ) : done ? (
          <p className="mb-6 text-sm text-muted-foreground">Your password is reset and every device was signed out. Sign in with the new password.</p>
        ) : (
          <form onSubmit={submit} noValidate>
            <InputField variant="auth" extra="mb-3" label="New password" placeholder="At least 10 characters" id="new-password" type="password" value={next} onChange={(e) => setNext(e.target.value)} />
            <InputField variant="auth" extra="mb-3" label="Confirm new password" id="confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            {error && <p className="mb-3 text-sm font-medium text-red-500">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              className="mt-1 inline-flex h-10 w-full items-center justify-center rounded-sm bg-primary px-6 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-60"
            >
              {busy ? "Saving…" : "Reset password"}
            </button>
          </form>
        )}
        <div className="mt-6 flex gap-4 text-sm font-medium">
          <Link to="/auth/sign-in" className="text-link hover:underline">
            Sign in
          </Link>
          <Link to="/auth/forgot-password" className="text-gray-600 hover:text-brand-500">
            Request a new link
          </Link>
        </div>
      </div>
    </div>
  );
}
